import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const usersAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'usersAPI',
    endpoints: (builder) => ({

        addUser: builder.mutation({
            query: (data) => ({
                url: `/UserManagement/AddUser`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateUser: builder.mutation({
            query: (data) => ({
                url: `/UserManagement/UpdateUser`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUserList: builder.mutation({
            query: (data) => ({
                url: `/UserManagement/GetUsers`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteUser: builder.mutation({
            query: (userId) => ({
                url: `/UserManagement/DeleteUser?UserId=${userId}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getUserByUserId: builder.query({
            query: (data) => ({
                url: `/UserManagement/GetUserDetailsByUserId?UserId=${data.userId}&EmailAddress=${data.EmailAddress}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        resetUserPassword: builder.mutation({
            query: (data) => ({
                url: `/UserManagement/ResetUserPassword/`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateUserToggle: builder.mutation({
            query: (data) => ({
                url: `/UserManagement/UpdateUserToggle`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })

    })
});

export const { 
    useAddUserMutation, 
    useUpdateUserMutation, 
    useGetUserListMutation, 
    useDeleteUserMutation, 
    useResetUserPasswordMutation,
    useUpdateUserToggleMutation
} = usersAPI;

export default usersAPI;